import React from 'react';
import { ModalController } from '../../../../components/Modal/ControlledModal';
import { Order, updateOrder } from '../../../../model/order';
import { useChanges, Form } from '../../../../components/Form/Form';
import { AsyncSearch } from '../../../../components/Form/AsyncSearch/AsyncSearch';
import { handleError } from '../../../../model/notification';
import { t } from '../../../../locales/translate';

interface Props {
  controller: ModalController<Order>;
}

export function EditOrderUser({ controller }: Props): JSX.Element {
  const [changes, , model, trackChanges] = useChanges<Order & { userId?: string }>({
    ...controller.model,
    userId: controller.model.user && controller.model.user.id,
  });

  async function handleOnSubmit(): Promise<void> {
    try {
      await updateOrder({ orderId: model.id, userId: changes.userId });
      controller.close();
    } catch (e) {
      handleError(e);
    }
  }

  return (
    <Form model={model} onInput={trackChanges}>
      {() => {
        controller.configure({
          onSubmit: handleOnSubmit,
          canSubmit: !!changes.userId,
        });
        return (
          <>
            <AsyncSearch required label={t.model.order.user} name="userId" searchIn={['user']} />
          </>
        );
      }}
    </Form>
  );
}
